/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { Button, Col, Row, Typography, Modal, message } from 'antd';
import { PARTNER_PRODUCTS, BUTTON_PRODUCT_STATUS } from 'constants/product';
import { RightOutlined } from '@ant-design/icons';
// import { updatePlanModal } from 'store/user';
import merchantAPI from 'services/merchants';
import Alert from 'components/Alert';
import productCard from 'assets/images/product_card.webp';
import styled from 'styled-components';
import trackingService from 'services/trackingService';
import EVENT_NAME from 'utils/const';

const ProductModalButton = styled(Button)`
  background-color: ${(props) => props.bgcolor};
  color: ${(props) => props.color};
  border-color: ${(props) => props.brcolor};

  &&:hover {
    background-color: ${(props) => props.hoverbgcolor};
    color: ${(props) => props.hovercolor};
    border-color: ${(props) => props.hoverbrcolor};
  }
`;

function ProductCard({ products, merchantId, fetchMerchantInfo, requestProduct }) {
  const [modalDisplay, setModelDisplay] = useState(false);
  const [sortedCard, setsortedCard] = useState([]);
  const [activateCard, setactivateCard] = useState([]);
  const [disableCard, setdisableCard] = useState([]);
  let sortingTemp = [];
  const temp = [];
  const activateTemp = [];
  const disableTemp = [];

  const planModal = useSelector((state) => state.user.planModal);
  const dispatch = useDispatch();
  // const togglePlanModal = () => {
  //   dispatch(updatePlanModal(!planModal));
  // };

  const productHandle = () => {
    if (Object.entries(products).length !== 0) {
      [...products].filter((key) => (PARTNER_PRODUCTS[key.key].show ? temp.push(key) : ''));
      sortingTemp = [...temp].sort((c, b) => c.value - b.value);
      setsortedCard(sortingTemp);
      sortingTemp.filter((key) =>
        key.value === 0 ? activateTemp.push(key) : disableTemp.push(key)
      );
      setactivateCard(activateTemp);
      setdisableCard(disableTemp);
    }
  };

  const ModelOpen = (val) => {
    setModelDisplay(val);
    productHandle();
  };

  const handleCancel = () => {
    setModelDisplay(false);
  };

  const raiseRequestProduct = async (productSelected, productKey) => {
    message.info({
      content: 'Mail Sending'
    });

    const response = await merchantAPI.raiseProductRequest({
      merchant_id: merchantId,
      product: productSelected,
      product_key: productKey
    });
    handleCancel();
    if (response.success) {
      message.success({
        content: 'Request has Been Raised'
      });
      fetchMerchantInfo();
    } else {
      console.log('something went wrong');
      Alert('something went wrong', 'Please contact support team for this', 'error');
    }
  };

  useEffect(() => {
    productHandle();
  }, []);

  return (
    <div
      style={{
        position: 'relative',
        height: '100%',
        background: `url(${productCard}) no-repeat`,
        backgroundSize: 'cover',
        padding: '5%',
        borderRadius: '13px',
        boxShadow: '0px 1px 6px #00000014'
      }}
    >
      {Object.entries(activateCard).length > 0 ? (
        <>
          <Typography.Title
            level={4}
            style={{ margin: '0', alignItems: 'center', letterSpacing: '0px' }}
          >
            Activated Products
          </Typography.Title>
          <Row
            key="Activate Products"
            style={
              Object.entries(activateCard).length > 2
                ? { paddingTop: '6%' }
                : { display: 'list-item', paddingTop: '6%' }
            }
          >
            {Object.entries(activateCard).map(([key, value]) => (
              <Col
                key={value.key}
                xs={{ span: 12 }}
                lg={{ span: 12 }}
                md={{ span: 12 }}
                style={
                  Object.entries(activateCard).length > 4 && key > 2
                    ? {
                        display: 'none'
                      }
                    : ''
                }
              >
                <Row key={value.key}>
                  {PARTNER_PRODUCTS[value.key].icon}
                  <Typography.Text
                    style={{
                      fontSize: '1rem',
                      margin: '6%'
                    }}
                  >
                    {PARTNER_PRODUCTS[value.key].label}
                  </Typography.Text>
                </Row>
              </Col>
            ))}
            {Object.entries(activateCard).length > 4 ? (
              <Col
                key="Tab"
                xs={{ span: 12 }}
                lg={{ span: 12 }}
                md={{ span: 12 }}
                style={{ marginTop: '5%' }}
              >
                <Row justify="start">
                  <Typography.Link
                    onClick={ModelOpen}
                    style={{
                      font: '2rem'
                    }}
                    underline
                  >
                    +{Object.entries(activateCard).length - 3} More
                  </Typography.Link>
                </Row>
              </Col>
            ) : (
              ''
            )}
          </Row>
        </>
      ) : (
        <>
          <Typography.Title
            level={4}
            style={{ margin: '0', alignItems: 'center', letterSpacing: '0px' }}
          >
            Our Products
          </Typography.Title>
          <Row key="Our Products" style={{ paddingTop: '6%' }}>
            {Object.entries(disableCard).map(([key, value]) => (
              <Col
                key={key}
                xs={{ span: 12 }}
                lg={{ span: 12 }}
                md={{ span: 12 }}
                style={
                  key > 2
                    ? {
                        display: 'none'
                      }
                    : ''
                }
              >
                <Row key={value.key}>
                  {PARTNER_PRODUCTS[value.key].icon}
                  <Typography.Text
                    style={{
                      fontSize: '1rem',
                      margin: '6%'
                    }}
                  >
                    {' '}
                    {PARTNER_PRODUCTS[value.key].label}
                  </Typography.Text>
                </Row>
              </Col>
            ))}
            <Col xs={{ span: 12 }} lg={{ span: 12 }} md={{ span: 12 }} style={{ marginTop: '5%' }}>
              <Row justify="start">
                <Typography.Link
                  onClick={ModelOpen}
                  style={{
                    font: '2rem'
                  }}
                  underline
                >
                  +{Object.entries(disableCard).length - 3} More
                </Typography.Link>
              </Row>
            </Col>
          </Row>
        </>
      )}

      <Row
        justify="end"
        style={
          Object.entries(activateCard).length === 1 ? { paddingTop: '17%' } : { paddingTop: '5%' }
        }
      >
        <Col xs={{ span: 14 }} lg={{ span: 14 }} md={{ span: 14 }}>
          {requestProduct ? (
            <Button
              type="primary"
              size="large"
              style={{
                boxShadow: '0px 3px 6px #0000000f'
              }}
              onClick={(value) => {
                trackingService.trackEvent(EVENT_NAME.BUTTON_CLICK, {
                  name: 'Request Product Activation'
                });
                ModelOpen(value);
              }}
            >
              Request For Activation <RightOutlined />
            </Button>
          ) : (
            <Button
              type="primary"
              size="large"
              style={{
                boxShadow: '0px 3px 6px #0000000f'
              }}
              disabled
              // onClick={() =>
              //   requestProduct === undefined
              //     ? Alert("You don't have access", 'Please contact support team for this', 'info')
              //     : togglePlanModal()
              // }
            >
              Request For Activation <RightOutlined />
            </Button>
          )}
        </Col>
      </Row>
      <Modal open={modalDisplay} onCancel={handleCancel} footer={null}>
        <Row
          style={{
            padding: '3%'
          }}
        >
          <Col xs={{ span: 24 }} lg={{ span: 24 }} md={{ span: 24 }}>
            <Typography.Title
              level={4}
              style={{
                marginLeft: '0',
                alignItems: 'center',
                letterSpacing: '0px'
              }}
            >
              Raise Request activation For New Products
            </Typography.Title>
          </Col>
        </Row>
        {Object.entries(sortedCard).map(([key, value]) => (
          <Row key={key} style={{ padding: '3%' }}>
            <Col key={value.key} xs={{ span: 12 }} lg={{ span: 12 }} md={{ span: 12 }}>
              <Row key={value.key}>
                {PARTNER_PRODUCTS[value.key].icon}
                <Typography.Text
                  style={{
                    fontSize: '1rem',
                    fontWeight: '500',
                    letterSpacing: '0px',
                    marginLeft: '3%'
                  }}
                >
                  {PARTNER_PRODUCTS[value.key].label}
                </Typography.Text>
              </Row>
            </Col>
            <Col xs={{ span: 12 }} lg={{ span: 12 }} md={{ span: 12 }}>
              <Row justify="end">
                <ProductModalButton
                  type="primary"
                  bgcolor={BUTTON_PRODUCT_STATUS[value.value].bgColor}
                  color={BUTTON_PRODUCT_STATUS[value.value].color}
                  brcolor={BUTTON_PRODUCT_STATUS[value.value].brColor}
                  hovercolor={BUTTON_PRODUCT_STATUS[value.value].hovercolor}
                  hoverbgcolor={BUTTON_PRODUCT_STATUS[value.value].hoverbgColor}
                  hoverbrcolor={BUTTON_PRODUCT_STATUS[value.value].hoverbrColor}
                  style={{
                    width: '123px',
                    height: '32px',
                    fontSize: '13px'
                  }}
                  onClick={
                    value.value === 1
                      ? () => {
                          raiseRequestProduct(PARTNER_PRODUCTS[value.key].label, value.key);
                        }
                      : () => {
                          'empty';
                        }
                  }
                >
                  {BUTTON_PRODUCT_STATUS[value.value].label}
                </ProductModalButton>
              </Row>
            </Col>
          </Row>
        ))}
      </Modal>
    </div>
  );
}

ProductCard.propTypes = {
  products: PropTypes.instanceOf(Object).isRequired,
  merchantId: PropTypes.number.isRequired,
  fetchMerchantInfo: PropTypes.func.isRequired,
  requestProduct: PropTypes.bool.isRequired
};

export default ProductCard;
